// extracted by css-extract-rspack-plugin
export default {"container":"LeadingVisual-module__container__yTsIiFp"};